import { render, staticRenderFns } from "./CatalogoTiposObras.vue?vue&type=template&id=1bdad87a"
import script from "./CatalogoTiposObras.vue?vue&type=script&lang=js"
export * from "./CatalogoTiposObras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports